import { render, staticRenderFns } from "./VCarForm.vue?vue&type=template&id=52562161"
import script from "./VCarForm.vue?vue&type=script&lang=js"
export * from "./VCarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports